import { GridRowId } from '@mui/x-data-grid-pro';
import React, { useState } from 'react';
import { ExternalRowSelectionContext } from 'src/common/components/ConfigurableTable/Components/Rows/ExternalRowSelection/ExternalRowSelectionContext';

export const ExternalRowSelectionProvider = ({ children }: { children: React.ReactNode }) => {
  const [selectedIds, setSelectedIds] = useState<Set<GridRowId>>(new Set());

  const toggleRow = (id: GridRowId) => {
    setSelectedIds((selectedIds) => {
      const newSelectedIs = new Set(selectedIds);
      if (newSelectedIs.has(id)) {
        newSelectedIs.delete(id);
      } else {
        newSelectedIs.add(id);
      }

      return newSelectedIs;
    });
  };

  const toggleAll = (allPageIds: GridRowId[]) => {
    setSelectedIds((selectedIds) => {
      const hasAllSelected = allPageIds.every((id) => selectedIds.has(id));

      if (hasAllSelected) {
        return new Set();
      }

      return new Set(allPageIds);
    });
  };

  const unSelectAll = () => {
    setSelectedIds(new Set());
  };

  return (
    <ExternalRowSelectionContext.Provider
      value={{
        selectedIds,
        toggleRow,
        unSelectAll,
        toggleAll,
        setSelectedIds,
      }}
    >
      {children}
    </ExternalRowSelectionContext.Provider>
  );
};
